import TypeMapping from '../Model/TypeMapping';
import { FileValue } from '../../../DataObject/Type/File/FileValue';

export default function getExternalId(fileValue: FileValue,
                                      typeMapping: TypeMapping)
{
    return `${fileValue.name}-${typeMapping.entityType.getName()}`;
}
